export function getBrowserTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function getTimezoneAbbr(reference: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat("en", { timeZoneName: "short" }).formatToParts(reference);
  return parts.find((p) => p.type === "timeZoneName")?.value ?? "";
}

export function formatTime(utcIso: string): string {
  return new Intl.DateTimeFormat([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(new Date(utcIso));
}

export function formatDateHeader(utcIso: string, locale?: string): string {
  return new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
    weekday: "short",
  }).format(new Date(utcIso));
}

export function formatDateRange(startUtc: string | null, endUtc: string | null): string {
  if (!startUtc || !endUtc) return "";
  const a = formatDateHeader(startUtc);
  const b = formatDateHeader(endUtc);
  return a === b ? a : `${a} → ${b}`;
}

// Returns YYYY-MM-DD in browser timezone — used for grouping items by day.
export function getLocalDateKey(utcIso: string): string {
  return new Intl.DateTimeFormat("en-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date(utcIso));
}

// datetime-local input value (no timezone) → UTC ISO. Browser interprets the input as local time.
export function localInputToUtc(value: string): string {
  return new Date(value).toISOString();
}

// UTC ISO → datetime-local string in browser tz, suitable for <input type="datetime-local" />.
export function utcToLocalInput(utcIso: string): string {
  const d = new Date(utcIso);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
